/** Client-side line id for new/duplicated rows before Firestore save. */
export function generateLineClientId(prefix = 'line') {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

function cloneDeep(value) {
  if (value === null || value === undefined) return value;
  if (value instanceof File) return value;
  if (value instanceof Date) return new Date(value.getTime());
  if (Array.isArray(value)) return value.map(cloneDeep);
  if (typeof value === 'object') {
    const out = {};
    for (const key of Object.keys(value)) {
      out[key] = cloneDeep(value[key]);
    }
    return out;
  }
  return value;
}

/**
 * Full copy of a line's current form state for duplicate-line actions.
 * Strips only Firestore identity / audit fields so the clone saves as a new line.
 */
export function duplicateLineItem(source, opts = {}) {
  if (!source || typeof source !== 'object') return null;

  const clone = cloneDeep(source);

  clone.id = opts.newId || generateLineClientId('line');
  delete clone.docId;
  delete clone.createdAt;
  delete clone.updatedAt;
  delete clone.activityLog;

  if (opts.orderId !== undefined) clone.orderId = opts.orderId;
  if (opts.lineNumber !== undefined) clone.lineNumber = opts.lineNumber;

  clone.isNew = true;
  clone.modified = true;
  clone.isExpanded = opts.isExpanded !== undefined ? opts.isExpanded : true;

  return clone;
}
